import styled from "styled-components";

export const SelectedChallengesList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 32px;
  @media (min-width: 1024px) {
    gap: 30px;
  }
`;

export const EstimatedWrapper = styled.div`
  max-width: 585px;
  margin: 0 auto;
  label {
    span {
      margin-left: 10px;
    }
  }
  .price-tip {
    margin-bottom: 3px;
    max-height: 0px;
    transition: 0.3s ease-in-out;
    visibility: hidden;
    p {
      font-size: ${({ theme }) => theme.fontSize.s};
      font-style: normal;
      font-weight: 400;
      line-height: 17px;
      width: 100%;
      margin: 0;
      color: ${({ theme }) => theme.colors.dark};
      a {
        color: ${({ theme }) => theme.colors.red};
      }
    }
    &.active {
      visibility: visible;
      max-height: 75rem;
    }
  }
`;
